// extracted by css-extract-rspack-plugin
export default {"container":"H4_OTzQ4uRgP0RDR"};